module.exports = __webpack_public_path__ + "static/img/league_building_01.aaa677f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/league_building_01.png
// module id = o3DJ
// module chunks = 0